// BookmarkCheckBurst.tsx
import React, { useEffect, useState } from 'react';
import { LuBookmarkCheck } from 'react-icons/lu';
import styles from './BookmarkCheckBurst.module.css';
import { FaRegCheckCircle } from "react-icons/fa";
type TriggerMode = 'mount' | 'hover' | 'both' | 'click' | 'skip';

type BookmarkCheckBurstProps = {
    size?: number;
    color?: string;
    className?: string;
    title?: string;
    trigger?: TriggerMode;
    mountDelay?: number;
    onClick?: () => void;
};

const PARTICLE_COLORS = [
    '#34d399',
    '#22c55e',
    '#86efac',
    '#16a34a',
    '#4ade80',
    '#15803d'
];

export default function BookmarkCheckBurst({
    size = 18,
    color = '#4bb4bcff',
    className = '',
    title = 'Confirmed',
    trigger = 'mount',
    mountDelay = 80,
    onClick
}: BookmarkCheckBurstProps) {
    const [animating, setAnimating] = useState(false);

    const replayAnimation = () => {
        setAnimating(false);
        requestAnimationFrame(() => {
            requestAnimationFrame(() => setAnimating(true));
        });
    };
    const difTime = ((new Date().getTime()) - ((window.global_lib_mounted || 0))) < 300;

    useEffect(() => {
        if ((trigger === 'mount' || trigger === 'both') && difTime) {
            const t = window.setTimeout(() => { replayAnimation() }, mountDelay);
            return () => window.clearTimeout(t);
        }
    }, [trigger, mountDelay]);

    const handleMouseEnter = () => {
        if ((trigger === 'hover' || trigger === 'both') && difTime) replayAnimation();
    };

    const handleClick = () => {
        if (trigger === 'click' && difTime) replayAnimation();
        onClick?.();
    };

    return (
        <button

            type="button"
            title={title}
            aria-label={title}
            className={`${styles.checkButton} ${animating ? styles.animate : ''} ${className}`}
            onMouseEnter={handleMouseEnter}
            onClick={handleClick}
            style={{ ['--check-color' as string]: color }}
        >
            <div className={styles.checkWrapper}>
                <div className={styles.ripple} />
                <div className={styles.icon}>
                    <FaRegCheckCircle size={size} color={color} />
                </div>

                <div className={styles.particles} style={{ ['--total-particles' as string]: 6 }}>
                    {PARTICLE_COLORS.map((particleColor, i) => (
                        <div
                            key={i}
                            className={styles.particle}
                            style={
                                {
                                    ['--i' as string]: i + 1,
                                    ['--color' as string]: particleColor
                                } as React.CSSProperties
                            }
                        />
                    ))}
                </div>
            </div>
        </button>
    );
}